import { mapGetters } from 'vuex';

export default {
  watchQuery: true,
  head () {
    return this.publicPage.head || {};
  },
  computed: {
    ...mapGetters('cms', {
      publicPageById: 'pageById',
      publicNavigation: 'navigation',
    }),
    publicPage () {
      return this.publicPageById(this.$options.cmsId) || {};
    },
    content () {
      return this.publicPage.content || {};
    },
  },
  methods: {
    publicPageAvailable (id) {
      return this.publicNavigation.some(page => page.id === id);
    },
    publicPath (id) {
      return this.publicNavigation.find(page => page.id === id)?.path;
    },
  },
};
